export default __webpack_public_path__ + "static/media/BB_11.b62fa1a5.png";